import React from 'react';
import { useState,useRef } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Link } from 'react-router-dom';
import Nav from '../Nav/Nav'
import GridViewRoundedIcon from '@mui/icons-material/GridViewRounded';
import './orders.css'


const Orders = () => {  
  
    const tableRef = useRef(null);
    const columns = [
        { field: "id", headerName: "P_id", width: 100 },
        { field: "list", headerName: "Property Listing", width: 200 },
        { field: "sell",headerName: "Seller Details",width: 200,},
        { field: "escrow", headerName: "Date of Escrow", width: 200 },
        { field: "approve", headerName: "Date of Approval", width: 200 },
        {field: "deed", headerName: "Property Deed",width: 200,
        renderCell: (params) => {
            return (<>
                  <button  className='WidgetLgButton'>View</button>
                  </>);
          },
        },
        {field: "action", headerName: "Actions",width: 200,
        renderCell: (params) => {
            return (<>
                  <button  className='WidgetLgButton'>View</button>
                  </>);
          },
        },
          ];

    const data=[
      {id:"1", list:"Kohinoor Apartmnets", sell:"Henry B", escrow: "29/10/22", approve: "pending"},
      {id:"2", list:"Kohinoor Apartmnets", sell:"Jessie F", escrow: "29/10/22", approve: "pending",},
      {id:"3", list:"Kohinoor Apartmnets", sell:"Henry B", escrow: "29/10/22", approve: "27/11/22"},
          ]
      

    const columns2 = [
        { field: "id", headerName: "P_id", width: 100 },
        { field: "list", headerName: "Property Listing", width: 200 },
        { field: "buy",headerName: "Buyer Details",width: 200,},
        { field: "escrow", headerName: "Date of Escrow", width: 200 },
        { field: "approve", headerName: "Date of Approval", width: 200 },
        {field: "deed", headerName: "Property Deed",width: 200,
        renderCell: (params) => {
            return (<>
                  <button  className='WidgetLgButton'>View</button>
                  </>);
          },
        },
        {field: "action", headerName: "Actions",width: 200,
          renderCell: (params) => {
            return (<>
                  <button className='WidgetLgButton'>View</button>
                  </>);},},
          ];

    const data2=[
      {id:"1", list:"Kohinoor Apartmnets", buy:"Cassie F", escrow: "29/10/22", approve: "pending"},
      {id:"2", list:"Kohinoor Apartmnets", buy:"Kate B", escrow: "29/10/22", approve: "pending"},
          ]
            
  
  return (
    <>
    <Nav/>
    <>
        <div className="orderTitle"><GridViewRoundedIcon />PROPERTIES BOUGHT</div>
        <div style={{"height":"50vh"}}>
         <DataGrid
            rows={data}
            disableSelectionOnClick
            columns={columns}
            pageSize={8}
            checkboxSelection
            ref={tableRef}
         />
         <br/>
        </div>
        <div className="orderTitle"><GridViewRoundedIcon/>PROPERTIES SOLD</div>
        <div style={{"height":"60vh"}}>
         <DataGrid
            rows={data2}
            disableSelectionOnClick
            columns={columns2}
            pageSize={8}
            checkboxSelection
            ref={tableRef}
         />
         <br/>
        </div>
     </>
    </>
  )
}

export default Orders